"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatureAttackAnimationType = void 0;
var CreatureAttackAnimationType;
(function (CreatureAttackAnimationType) {
    // Fallback
    CreatureAttackAnimationType["Default"] = "default";
    // Base character animations
    CreatureAttackAnimationType["HorizontalSlash"] = "horizontalSlash";
    CreatureAttackAnimationType["Attack360"] = "attack360";
    CreatureAttackAnimationType["VerticalSlash"] = "verticalSlash";
    CreatureAttackAnimationType["MagicAttackOneHanded"] = "magicAttackOneHanded";
})(CreatureAttackAnimationType || (exports.CreatureAttackAnimationType = CreatureAttackAnimationType = {}));
